export default __webpack_public_path__ + "static/media/yayinlar2.8c4c1e60.png";